(function (root) {
  'use strict';
  function signature(item) {
    var props = item.properties || {};
    return JSON.stringify([String(item.variant_id || item.id), String(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id || ''), Object.keys(props).filter(function (key) { return key !== '_ZapietId'; }).sort().map(function (key) { return [key, props[key]]; })]);
  }
  function resolveLine(items, before) {
    var exact = items.find(function (item) { return item.key === before.key; });
    if (exact) return exact;
    var matches = items.filter(function (item) { return signature(item) === signature(before); });
    if (matches.length !== 1) throw Error('The cart changed. Review your items before trying again.');
    return matches[0];
  }
  function isQuantityChange(data) {
    return data && Number.isSafeInteger(data.quantity) && data.quantity >= 0 && (data.id || data.line) && Object.keys(data).every(function (key) { return ['id', 'line', 'quantity'].includes(key); });
  }
  if (typeof module === 'object' && module.exports) { module.exports = {signature:signature,resolveLine:resolveLine,isQuantityChange:isQuantityChange}; return; }
  if (!root || root.WTXCartAppBridge) return;
  var pending = false, boundCart, queued = false;
  root.WTXCartAppBridge = { pending: function () { return pending; } };
  function cartRoot() { return document.getElementById('rebuy-cart'); }
  function status(message) {
    var cart = cartRoot();
    if (!cart) return;
    var node = cart.querySelector('[data-wtx-cart-update-status]');
    if (!node) { node = document.createElement('p'); node.dataset.wtxCartUpdateStatus = ''; node.setAttribute('role', 'status'); node.style.cssText = 'margin:8px 16px;color:#344c37;font-size:14px'; (cart.querySelector('[data-rebuy-cart-anchor="footer"]') || cart).appendChild(node); }
    node.textContent = message;
  }
  function setPending(value) {
    pending = value;
    var cart = cartRoot();
    if (cart) { cart.classList.toggle('wtx-cart-writing', value); cart.setAttribute('aria-busy', String(value)); }
  }
  function refresh(cart) { return new Promise(function (resolve, reject) { var timer = setTimeout(function () { reject(Error('Your cart could not be refreshed. Please reload before checkout.')); }, 12000); cart.fetchShopifyCart(function () { clearTimeout(timer); resolve(); }); }); }
  async function read() {
    var response = await fetch((root.Shopify && root.Shopify.routes && root.Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(12000) });
    if (!response.ok) throw Error('Your cart could not be refreshed. Please try again.');
    var cart = await response.json();
    if (!Array.isArray(cart.items)) throw Error('Your cart could not be refreshed. Please try again.');
    return cart;
  }
  function bindQuantity(cart) {
    if (!cart || boundCart === cart || typeof cart.changeItem !== 'function' || typeof cart.fetchShopifyCart !== 'function') return;
    boundCart = cart;
    var original = cart.changeItem;
    cart.changeItem = function (data, options) {
      if (!isQuantityChange(data) || options === true || options && options.raw) return original.apply(this, arguments);
      var opts = typeof options === 'function' ? { success: options } : Object.assign({}, options || {});
      var current = cart.getCart(), before = current && current.items && (data.line ? current.items[data.line - 1] : current.items.find(function (item) { return item.key === String(data.id); }));
      if (!before || pending) { if (typeof opts.error === 'function') opts.error(Error('A cart update is still finishing. Please try again.')); return; }
      setPending(true);
      status('Updating your cart…');
      (async function () {
        try {
          var fresh = await read(), line = resolveLine(fresh.items, before);
          if (line.quantity !== before.quantity) throw Error('The quantity changed. Review your cart before trying again.');
          var result = await new Promise(function (resolve, reject) {
            original.call(cart, { id: line.key, quantity: data.quantity }, Object.assign({}, opts, { success: resolve, error: reject }));
          });
          var confirmed = result && Array.isArray(result.items) ? result : await read();
          var after = data.quantity === 0 ? null : resolveLine(confirmed.items, line);
          if (data.quantity === 0 ? confirmed.items.some(function (item) { return item.key === line.key; }) : after.quantity !== data.quantity) throw Error('The requested quantity was not available. Review the quantity shown in your cart.');
          await refresh(cart);
          status('');
          if (typeof opts.success === 'function') opts.success(confirmed);
        } catch (error) {
          try { await refresh(cart); } catch (refreshError) {}
          status(error.message || 'Your cart could not be updated. Review it and try again.');
          if (typeof opts.error === 'function') opts.error(error);
        } finally { setPending(false); }
      })();
    };
  }
  function schedule() { if (queued) return; queued = true; queueMicrotask(function () { queued = false; bindQuantity(root.Rebuy && root.Rebuy.Cart); }); }
  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest('#rebuy-cart .rebuy-cart__checkout-button, #rebuy-cart .rebuy-cart__shop-pay-button, #rebuy-cart .rebuy-cart__flyout-item-quantity-widget-button, #rebuy-cart .rebuy-cart__flyout-item-remove');
    if (target && pending) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  ['rebuy.loaded','rebuy:cart.ready','rebuy:smartcart.ready','rebuy:smartcart.show'].forEach(function(name){document.addEventListener(name,schedule);});
  schedule();
})(typeof window === 'undefined' ? null : window);
